<template>
  <div class="n-input" :class="{ 'has-error': errorMessage }">
    <label :for="inputId" :class="{ 'sr-only': hideLabel }">{{ label }}</label>
    <!-- If the multiline prop = true, render a textarea -->
    <textarea
      v-if="multiline"
      class="control"
      v-model="value"
      :id="inputId"
      :name="name"
      :disabled="disabled"
      :placeholder="placeholder"
      @change="emit('change', value)"
    ></textarea>
    <!-- Else render an input -->
    <input
      v-else
      class="control"
      v-model="value"
      :id="inputId"
      :name="name"
      :type="type"
      :disabled="disabled"
      :placeholder="placeholder"
      @change="emit('change', value)"
    />
    <span v-if="errorMessage" class="error-message">{{ errorMessage }}</span>
  </div>
</template>
<script lang="ts" setup>
import { PropType } from 'vue';
import { useIdGenerator } from '@/shared/designsystem/useIdGenerator';
import { useVModel } from '@vueuse/core';

defineOptions({
  name: 'n-text-input',
});

const props = defineProps({
  id: {
    type: String,
  },
  type: {
    type: String as PropType<'text' | 'email' | 'password' | 'search'>,
    default: 'text',
  },
  label: {
    type: String,
  },
  name: {
    type: String,
  },
  modelValue: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
  },
  errorMessage: {
    type: String,
  },
  multiline: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  hideLabel: {
    type: Boolean,
  },
});

const { inputId } = useIdGenerator(props.id);

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void;
  (e: 'change', value: string): void;
}>();

const value = useVModel(props, 'modelValue', emit);
</script>

<style lang="scss" scoped>
@use '../../../styles/accessibility' as *;
@use '../../../styles/colours' as *;
@use '../../../styles/input' as *;
</style>
